export default "__VITE_ASSET__DBb_GhEh__"